module.exports = __webpack_public_path__ + "static/media/white24crm.36b8d3e1.png";